import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtAppDownloadButton from "../general/NtAppDownloadButton";
import { useMobile } from "../../../hooks/useMobile";

function NtMobileDownloadSection(props) {
  const isMobile = useMobile();
  return (
    <NtMarketingSectionContainer style={styles.container}>
      <View style={{ flexDirection: isMobile ? "column" : "row" }}>
        <View style={{ flex: 1, alignItems: "center" }}>
          <Image
            style={[
              {
                width: 150,
                height: 300,
                resizeMode: "contain",
              },
            ]}
            source={require("../../../assets/images/marketing/7afffde683a9bd23580f12ed3b03d5a71d7a944e.png")}
          />
        </View>
        <View
          style={{
            marginTop: isMobile ? 80 : 0,
            flex: 1,
            justifyContent: "center",
          }}
        >
          <NtSectionTitle style={{ textAlign: "left" }}>
            DOWNLOAD OUR TALK{"\n"}APP NOW
          </NtSectionTitle>
          <NtSectionDescription style={{ marginTop: 8 }}>
            The Talk App allows you to make calls via your mobile phone's Wi-Fi
            / LTE / 3G / 4G / 5G connection without roaming charges. It is
            available for iOS and Android mobile devices.
          </NtSectionDescription>

          <View
            style={{
              marginTop: 30,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <NtAppDownloadButton
              type="android"
              containerStyle={{ marginRight: 15 }}
              onPress={() => {
                window.open(
                  "https://play.google.com/store/apps/details?id=org.netTalk.smartphone"
                );
              }}
            />

            <NtAppDownloadButton
              type="apple"
              containerStyle={{}}
              onPress={() => {
                window.open(
                  "https://apps.apple.com/us/app/nt-connect-calls-messages/id397090127"
                );
              }}
            />
          </View>
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 60,
    paddingBottom: 60,
  },
});

export default NtMobileDownloadSection;
